(function Module() {
	'use strict';

	var util = require('../../static/js/imported-parnell-common-modules').util;

	mySynch.controller('WhitePapersController', [
		'$scope',
		'$window',
		'$timeout',
		'ApiFactory',
		'CookieFactory',
		'clientLoggerService',
		function WhitePapersController($s, $window, $timeout, api, cookies, log) {
			$s.currentWhitePaper = null;
			$s.loadingWhitePaper = true;
			$s.showEmailForm = false;
			$s.emailingWhitePaper = false;
			$s.emailSent = false;
			$s.inputs = {
				email: null,
				message: null
			};

			$s.whitePapers = [
				{
					name: 'Culling Strategies',
					fileName: 'culling-strategies',
					thumbnailName: 'culling-strategies',
					description: 'Many dairy producers feel that their culling rates are high, but ' +
						'have little information on what is “normal” and to make comparisons amongst peer groups.'
				},
				{
					name: 'Economic Value of a Cow',
					fileName: 'economic-value-of-a-cow',
					thumbnailName: 'economic-value-of-a-cow',
					description: 'A simple formulation and solution to the replacement problem: ' +
						'A practical tool to assess the economic cow value, the value of a new ' +
						'pregnancy, and the cost of a pregnancy loss'
				},
				{
					name: 'Milk Urea Nitrogen',
					fileName: 'milk-urea-nitrogen',
					thumbnailName: 'milk-urea-nitrogen',
					description: 'What is Milk Urea Nitrogen (MUN) and how is it Interpreted? ' +
						'Dr. Doo-Hong Min, Extension Forage Specialist, MSU UPES Milk urea nitrogen (MUN) ' +
						'is another tool to assess the protein and energy balance status of a group of ' +
						'dairy cows and can be used for minimizing feed costs while maximizing production.'
				},
				{
					name: 'Understanding Estrus Synchronization',
					fileName: 'understanding-estrus-synchronization',
					thumbnailName: 'understanding-estrus-synchronization',
					description: 'Reproductive failure is a major source of economic loss in the beef ' +
						'industry. The majority of this loss occurs because cows do not ' +
						'become pregnant during a defined breeding season.'
				},
				{
					name: 'Effect of a Second Treatment with Prostaglandin',
					fileName: 'effect-of-a-second-treatment-with-pg',
					thumbnailName: 'effect-of-a-second-treatment-with-pg',
					description: ''
				}
			];
			$s.showWhitePaper = function showWhitePaper(whitePaperFileName) {
				$('#pdf').remove();
				$('#pdf-container').append(
					'<object id="pdf" type="application/pdf" data="/files/white-papers/' +
					whitePaperFileName + '.pdf"><span>PDF plugin is not available.</span></object>');

				$s.currentWhitePaper = _.find($s.whitePapers, {fileName: whitePaperFileName});
				$s.loadingWhitePaper = false;
			};

			$s.toggleEmailForm = function toggleEmailForm() {
				$s.showEmailForm = !$s.showEmailForm;

				if ($s.emailSent) {
					$s.hideEmail();
				}
			};
			$s.emailCurrentWhitePaper = function emailCurrentWhitePaper(isValid) {
				if (isValid) {
					$s.emailingWhitePaper = true;

					var message = $s.inputs.message ? $s.inputs.message : 'Take a look at this white paper called ' + $s.currentWhitePaper.name + ' .';

					api.emailWhitePaper({
						emailAddress: $s.inputs.email,
						sender: {
							firstName: cookies.user.FirstName,
							lastName: cookies.user.LastName
						},
						message: message,
						whitePaper: $s.currentWhitePaper
					}, function whitePaperEmailed(err, result) {
						$s.emailingWhitePaper = false;

						if (err) {
							log.error(MSF.notify.danger('unable to email white paper: ' + err));

							return;
						}

						$s.emailSent = true;
					});
				} else {
					var emailFormError = null;

					if ($s.formEmailCurrentWhitePaper.$error.required) {
						_.forEach($s.formEmailCurrentWhitePaper.$error.required, function appendErrorMessage(item, index, collection) {
							if (index === 0) {
								emailFormError = util.string.camelToTitle(item.$name);
							} else {
								emailFormError += util.string.camelToTitle(item.$name);
							}

							if ((index + 1) < collection.length) {
								if (((collection.length) - (index + 1)) === 1) {
									if (collection.length > 2) {
										emailFormError += ', and ';
									} else {
										emailFormError += ' and ';
									}
								} else {
									emailFormError += ', ';
								}
							}
						});

						emailFormError += ' is required.';
					}

					if ($s.formEmailCurrentWhitePaper.$error.email) {
						if (emailFormError) {
							emailFormError += ' Email address is invalid.';
						} else {
							emailFormError = 'Email address is invalid.';
						}
					}

					MSF.notify.danger(emailFormError || 'An error has occured. Please check your inputs.');
				}
			};
			$s.resetEmail = function resetEmail() {
				$s.showEmailForm = true;
				$s.emailingWhitePaper = false;
				$s.emailSent = false;
				$s.inputs = {
					email: null,
					message: null
				};
			};
			$s.hideEmail = function hideEmail() {
				$s.resetEmail();
				$s.showEmailForm = false;
			};

			$s.expandWhitePaper = function expandWhitePaper() {
				$window.open('/files/white-papers/' + $s.currentWhitePaper.fileName + '.pdf', '_blank');
			};

			$timeout(function initializeTooltip() {
				$('[data-toggle="tooltip"]').tooltip();
				$s.showWhitePaper($s.whitePapers[0].fileName);
			}, 0);
		}
	]);
})();
